const ACCESS_TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";

function safeStorage(): Storage | null {
  if (typeof window === "undefined") return null;
  try {
    const ls = window.localStorage;
    if (!ls) return null;
    return ls;
  } catch {
    return null;
  }
}

function isValidToken(value: string | null): value is string {
  if (!value) return false;
  const trimmed = value.trim();
  if (trimmed === "" || trimmed === "null" || trimmed === "undefined") {
    return false;
  }
  return true;
}

export function getToken(): string | null {
  const ls = safeStorage();
  if (!ls) return null;
  try {
    const v = ls.getItem(ACCESS_TOKEN_KEY);
    return isValidToken(v) ? v : null;
  } catch {
    return null;
  }
}

export function getRefreshToken(): string | null {
  const ls = safeStorage();
  if (!ls) return null;
  try {
    const v = ls.getItem(REFRESH_TOKEN_KEY);
    return isValidToken(v) ? v : null;
  } catch {
    return null;
  }
}

export function setTokens(accessToken: string, refreshToken: string): void {
  const ls = safeStorage();
  if (!ls) return;
  if (!isValidToken(accessToken) || !isValidToken(refreshToken)) return;
  try {
    ls.setItem(ACCESS_TOKEN_KEY, accessToken);
    ls.setItem(REFRESH_TOKEN_KEY, refreshToken);
  } catch {
    // ignore quota / private-mode failures
  }
}

export function clearTokens(): void {
  const ls = safeStorage();
  if (!ls) return;
  try {
    ls.removeItem(ACCESS_TOKEN_KEY);
    ls.removeItem(REFRESH_TOKEN_KEY);
  } catch {
    // ignore
  }
}
